import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { SignersText } from '../SignersText';

export const SignersTooltip: React.FC<{
	constituentCount: number;
	constituentCountLocalized: string;
	isFormer: boolean;
	onTooltipClick: () => void;
}> = ({ constituentCount, constituentCountLocalized, isFormer, onTooltipClick }) => {
	return (
		<InfoTooltip aria-label="Information about signers" data-qa="dm-info-tooltip" onClick={onTooltipClick}>
			<SignersText
				constituentCount={constituentCount}
				constituentCountLocalized={constituentCountLocalized}
				isFormer={isFormer}
			/>
		</InfoTooltip>
	);
};
